import Invoice from '@/components/modules/invoice/list/index';
import InvoiceDetails from '@/components/modules/invoice/details/invoice-details';
import InvoiceVoucher from '@/components/modules/invoice/details/voucher-details';
import InvoiceSummary from '@/components/modules/invoice/summary/index';
import Wallet from '@/components/modules/invoice/wallet/index';

const invoice = [
  {
    path: '/invoices',
    name: 'Invoice',
    component: Invoice,
    meta: {
      title: 'Invoices',
      requiresAuth: true,
    },
  },
  {
    path: '/invoice/:invoiceId/details',
    name: 'InvoiceDetails',
    component: InvoiceDetails,
    meta: {
      title: 'Invoice Details',
      requiresAuth: true,
    },
  },
  {
    path: '/invoice/:invoiceId/:type',
    name: 'InvoiceVoucher',
    component: InvoiceVoucher,
    meta: {
      title: 'Voucher Details',
      requiresAuth: true,
    },
  },
  {
    path: '/invoice/summary',
    name: 'InvoiceSummary',
    component: InvoiceSummary,
    meta: {
      title: 'Invoices Summary',
      requiresAuth: true,
    },
  },
];

export default invoice;
